import { Divider, styled } from '@mui/material';

const StyledDivider = styled(Divider)(({ theme }) => ({
  borderBottomColor: '#D9D9D9',
  margin: theme.spacing(0.5, 0)
}));

export default StyledDivider;
